import React, { useContext, useEffect, useState, useRef } from "react";
import "./header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import $ from "jquery";
import cart from "../../assets/home/cart.svg";
import search from "../../assets/home/search.svg";
import AllSubHeader from "./AllSubHeader";
import closeBtn from "../../assets/slider-arrow/close.svg";
import RightArrow from "../../assets/slider-arrow/search-arrow.svg";
import SearchContext from "../context/SearchContext";
import useTranslation from "../../hooks/useTranslation";
import { BASE_URL_IMAGE } from "../../constants/constants";
import Cart from "../cart/cart";
import useAsync from "../../utils/useAsync/useAsync";
import CatgoryServices from "../../services/categoryServices";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addActiveCategoryID } from "../../Store/reducers/categorySlice";
import Cookies from "js-cookie";
import { MdArrowDropDownCircle } from "react-icons/md";
import { debounce } from "lodash";
import useCurrency from "../../hooks/useCurrency";
import useProductDetails from "../../hooks/useProductDetails";
import { changeScrolling } from "../../Store/reducers/clientSettingSlice";
import { FiPlus } from "react-icons/fi";
import useCart from "../../hooks/useCart";
import { GiGoldBar, GiKnot } from "react-icons/gi";
import { IoDiamondOutline } from "react-icons/io5";
import { productClearState } from "../../Store/reducers/productScrollSlice";
import { addActiveProductID } from "../../Store/reducers/productSlice";
import { CiSearch } from "react-icons/ci";
import { GoArrowRight } from "react-icons/go";
import { RiMenu2Fill } from "react-icons/ri";
import { HiOutlineXMark } from "react-icons/hi2";

function AllHeader() {
  const searchState = useContext(SearchContext);
  const { searchSideBar, HandleSearch, cartBar, HandleCart } = searchState;
  const [toggleSideBar, setSidebarToggle] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredChild, setHoveredChild] = useState({});
  const { cartLength } = useCart();
  const [toggleHeader, setToggleHeader] = useState(false);
  const allHeaderItem = useRef();

  const [showSubHeader, setShowSubHeader] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
   const [langOpen, setLangOpen] = useState(false);
  const [currOpen, setCurrOpen] = useState(false);
  const [openShop, setOpenShop] = useState(false);
  const headerData = useSelector((store) => store?.storeSettings?.header);
  const toggleScrolling = useSelector(
    (store) => store?.clientSettings?.toggleScrolling
  );

  const { handleCurrencyChange, defaultCurrency } = useCurrency();
  const { showingCurrency: currencies } = useSelector(
    (store) => store.currency
  );

  const {
    handleLanguageChange,
    showTranslatedValue,
    name: languageName,
  } = useTranslation();

  const { showingLanguages: languages } = useSelector(
    (store) => store.language
  );
  const userInfo = useSelector((store) => store?.auth?.userInfo);
  const isLoggedIn = Boolean(userInfo);

  const dispatch = useDispatch();

  const [searchTxt, setSearchTxt] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { cartList } = useProductDetails();

  let currentScroll = window.scrollY;

  const { data, error, loading } = useAsync(
    async () => await CatgoryServices.getShowingCategory()
  );

  function handleEShop() {
    setOpenShop(!openShop);
  }

  useEffect(() => {
    if (searchSideBar || toggleSideBar || cartBar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [searchSideBar, toggleSideBar, cartBar]);


  // let deltaY = 0;
  // const handleDelta = (e) => {
  //   deltaY = e.deltaY || 0;
  //   if (deltaY >= 0) {
  //     setToggleHeader(false);
  //   } else {
  //     setToggleHeader(true);
  //   }
  // }
  // document.addEventListener("wheel", handleDelta);

  // let scrollValue = 0;
  // const handleAllHeaderY = (e) => {
  //   if (e.touches[0].clientY < scrollValue) {
  //     // setToggleHeader(true);
  //     // allHeader.current.style.top = "-400px";
  //     setToggleHeader(false)
  //   } else {
  //     setToggleHeader(true)
  //     // allHeader.current.style.top = "0px";
  //   }
  // }

  // document.addEventListener("touchstart", (e) => {
  //   scrollValue = e.touches[0].clientY;
  // });

  // document.addEventListener("touchmove", handleAllHeaderY);

  let prevScrollposition = window.pageYOffset;
  window.onscroll = function () {
    let currentScrollPosition = window.pageYOffset;
    if (prevScrollposition > currentScrollPosition) {
      // document.getElementById("hide-header").style.top = "0";
      // mobileHeader.current.style.transform = "translateY(0)";
      setToggleHeader(false);
    } else {
      // document.getElementById("hide-header").style.top = "-80px"; /* adjust this value to the height of your header */
      // mobileHeader.current.style.transform = "translateY(-400px)";
      setToggleHeader(true);
    }
    prevScrollposition = currentScrollPosition;
  };

  function handleScroll() {
    const currentScrollPos = window.scrollY;
    const isScrollingDown = currentScrollPos > prevScrollPos;

    setShowSubHeader(!isScrollingDown || currentScrollPos < 200);

    setPrevScrollPos(currentScrollPos);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  useEffect(() => {
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 50) {
        $(".desktop-header").css({ "background-color": "#FFFFFF" });
      } else {
        $(".desktop-header").css({ "background-color": "#FFFFFF" });
      }
      if ($(window).scrollTop() > 50) {
        $("a").css("color", "#000");
      } else {
        $("a").css("color", "#000");
      }
    });
  }, []);

  const handleSearchTxt = () => {
    if (searchTxt.trim().length > 0) {
      HandleSearch();
      navigate(`/search?search=${searchTxt}`);
      setSearchTxt("");
    }
  };

  const handleKeyDown = (event) => {
    if (searchTxt.trim().length > 0 && event.key === "Enter") {
      HandleSearch();
      navigate(`/search?search=${searchTxt}`);
      setSearchTxt("");
    }
  };

  const openSidebar = () => {
    setSidebarToggle(!toggleSideBar);
  };

  const handleRedict = async (data) => {
    setSidebarToggle(!toggleSideBar);
    // dispatch(productClearState());
    await CatgoryServices.addTheCountsCategory(data);
    navigate(`/eshop/${data}`);
  };

  const RenderCategories = ({ categories }) => {
    if (!categories || categories.length === 0) {
      return null;
    }
    return (
      <div
        className="e-shop-header-category-grid"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {categories.map((category, i) => {
          return (
            <div className={`e-shop-body-categroy grid-section-${i}`} key={i}>
              <div
                className="header-sub-header cursor-pointer flex items-center gap-2 group"
                onClick={() => {
                  const landingPageSlugs = ["metals", "stones", "macrame"];
                  if (landingPageSlugs.some(slug => category.slug?.toLowerCase().includes(slug))) {
                    setSidebarToggle(false);
                    navigate(`/category-landing/${category.slug}`);
                  } else {
                    handleRedict(category.slug);
                  }
                }}
              >
                {showTranslatedValue(category.name)}
                {["metals", "stones", "macrame"].some(slug => category.slug?.toLowerCase().includes(slug)) && (
                  <GoArrowRight className="transition-all duration-300 text-sm" />
                )}
              </div>
              <ul className="categories-list">
                {category.children && category.children.length > 0 && !["metals", "stones", "macrame"].some(slug => category.slug?.toLowerCase().includes(slug)) && (
                  <RenderChildCategories 
                    children={category.children} 
                  />
                )}
              </ul>
            </div>
          );
        })}
      </div>
    );
  };

  const RenderChildCategories = ({ children }) => {
    const [hoveredChild, setHoveredChild] = useState(null);
    const [toggleChild, setToggleChild] = useState(false);
    return (
      <>
        {children &&
          children.length > 0 &&
          children.map((child, i) => (
            <>
              <li
                key={i}
                // onMouseEnter={() => { setHoveredChild(child); (child?.children.length > 0 && setToggleChild(true)) }}
                className="relative showHeaderChild headerListItems mb-1"
                // onMouseLeave={() => setHoveredChild(null)}
              >
                <div
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                    }
                  }}
                  className="cursor-pointer flex items-center justify-start gap-2"
                >
                  <span
                    onClick={() => handleRedict(child.slug)}
                    className={`${
                      toggleChild &&
                      (hoveredChild === child ||
                        (hoveredChild &&
                          hoveredChild.parentId === child._id)) &&
                      "underline"
                    }`}
                  >
                    {showTranslatedValue(child.name)}
                  </span>

                  {child.children.length > 0 && (
                    <FiPlus
                      onClick={() => {
                        setHoveredChild(child);
                        setToggleChild(true);
                        toggleChild &&
                          (hoveredChild === child ||
                            (hoveredChild &&
                              hoveredChild.parentId === child._id)) &&
                          setToggleChild(false);
                      }}
                      className={`transition-all duration-200 ease-in-out w-4 h-4 ${
                        toggleChild &&
                        (hoveredChild === child ||
                          (hoveredChild && hoveredChild.parentId === child._id))
                          ? "rotate-45"
                          : ""
                      }`}
                    />
                  )}
                </div>
              </li>
              {child.children.length > 0 &&
                (hoveredChild === child ||
                  (hoveredChild && hoveredChild.parentId === child._id)) && (
                  <div
                    className={`h-full w-[180px] overflow-hidden ${
                      toggleChild &&
                      (hoveredChild === child ||
                        (hoveredChild &&
                          hoveredChild.parentId === child._id)) &&
                      "mb-3"
                    }`}
                  >
                    <ul
                      className={`w-full customScrollbar transition-all duration-300 ease-in-out overflow-x-hidden max-h-[0px] overflow-hidden ${
                        toggleChild &&
                        (hoveredChild === child ||
                          (hoveredChild &&
                            hoveredChild.parentId === child._id)) &&
                        "py-2 !max-h-[120px] overflow-y-scroll pb-4"
                      }`}
                    >
                      {/* <RenderChildCategories children={child.children} /> */}
                      {child.children.map((item, i) => (
                        <li key={i} className="relative headerListItems pb-1">
                          <div
                            onClick={() => handleRedict(item.slug)}
                            className="cursor-pointer transition-all duration-300 ease-in-out hover:underline border-black"
                          >
                            <span>{showTranslatedValue(item.name)}</span>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
            </>
          ))}
      </>
    );
  };

  const RenderMobileCategories = ({ categories }) => {
    if (!categories || categories.length === 0) {
      return null;
    }
    return (
      <>
        {categories.map((category, i) => (
          <div key={i} className="e-shop-body-categroy mb-2">
            <div
              onClick={() => handleRedict(category.slug)}
              className="header-sub-header-mobile"
            >
              {showTranslatedValue(category?.name)}{" "}
            </div>
            <ul className="categories-list">
              {category.children && category.children.length > 0 && (
                <RenderMobileChildCategories children={category.children} />
              )}
            </ul>
          </div>
        ))}
      </>
    );
  };

  const [showMobileChild, setShowMobileChild] = useState(false);

  const RenderMobileChildCategories = ({ children }) => {
    return (
      <>
        {children &&
          children.length > 0 &&
          children.map((child, i) => (
            <li
              key={i}
              onClick={() => setHoveredChild(child)}
              className="relative"
              // onMouseLeave={() => setHoveredChild(null)}
            >
              <span className="!flex items-center gap-2 mt-2">
                <div
                  onClick={() => handleRedict(child?.slug)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                    }
                  }}
                  className=""
                >
                  <span>{showTranslatedValue(child.name)}</span>
                </div>
                {child.children.length > 0 && (
                  <span
                    className="w-[50px]"
                    onClick={() =>
                      showMobileChild === i
                        ? setShowMobileChild(false)
                        : setShowMobileChild(i)
                    }
                  >
                    <MdArrowDropDownCircle
                      className={`text-xl ${
                        showMobileChild === i && "rotate-180"
                      }`}
                    />
                  </span>
                )}
              </span>

              {child.children.length > 0 && showMobileChild === i && (
                <ul
                  className={`categories-list px-3 py-2 ${
                    showMobileChild !== i && "hidden"
                  }`}
                >
                  {child.children.map((item, idx) => (
                    <li key={idx} className="pb-1">
                      <div onClick={() => handleRedict(item.slug)}>
                        {showTranslatedValue(item.name)}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
      </>
    );
  };
  // useEffect(() => {
  //   setShowSubHeader(false);
  //   setTimeout(() => {
  //     setShowSubHeader(true);
  //   }, 200)

  // }, [showSubHeader])
  let categoryMenu = [];

  data[0]?.children?.forEach((el) => {
    if (el.slug.includes("metals")) {
      el.children.forEach((child) => {
        categoryMenu.push(child);
      });
    } else {
      categoryMenu.push(el);
    }
  });

  const mobileNav = {
    categories: categoryMenu,
    pages: [
      {
        title: showTranslatedValue(headerData?.headerMenu2),
        link: headerData?.headerMenu2Link,
      },
      {
        title: showTranslatedValue(headerData?.headerMenu3),
        link: headerData?.headerMenu3Link,
      },
      {
        title: showTranslatedValue(headerData?.headerMenu4),
        link: headerData?.headerMenu4Link,
      },
      {
        title: showTranslatedValue(headerData?.headerMenu5),
        link: headerData?.headerMenu5Link,
      },
      {
        title: isLoggedIn ? "Account" : "Login",
        link: isLoggedIn ? "/my-account" : "/login",
      },
    ].filter((page) => page.title),
  };

  const [activeCategory, setActiveCategory] = useState(null);

  // console.log(activeCategory);
  if (!headerData) {
    return;
  }

  return (
    <Wrapper>
      {showSubHeader && <AllSubHeader />}
      <header
        className="desktop-header"
        style={{
          backgroundColor: "#FFFFFF",
          top: showSubHeader ? "56px" : "0",
        }}
      >
        <div className="header-box">
          <Link to="/">
            <div
              className="logo"
              style={{
                backgroundImage: `url(${BASE_URL_IMAGE}${headerData?.logo[1]})`,
              }}
            ></div>
          </Link>
          <ul className="text-none header-item">
            {data?.[0]?.children
              ?.filter((cat) =>
                ["metals", "stones", "macrame"].some((slug) =>
                  cat.slug?.toLowerCase().includes(slug)
                )
              )
              .map((cat, idx) => {
                const getCategoryIcon = (slug) => {
                  const s = slug?.toLowerCase() || "";
                  if (s.includes("metals")) return <GiGoldBar className="hidden lg:inline-block mr-2 text-[1.1rem]" />;
                  if (s.includes("stones")) return <IoDiamondOutline className="hidden lg:inline-block mr-2 text-[1.2rem]" />;
                  if (s.includes("macrame")) return <GiKnot className="hidden lg:inline-block mr-2 text-[1.1rem]" />;
                  return null;
                };
                return (
                  <li className="header-list" key={cat.slug || idx}>
                    <Link
                      to={`/category-landing/${cat.slug}`}
                      className="relative a-tag transition-all duration-300 flex items-center"
                      style={{ color: "#000" }}
                      onClick={() => {
                        setSidebarToggle(false);
                      }}
                    >
                      {getCategoryIcon(cat.slug)}
                      <span
                        className="hover:border-b-2 hover:border-current pb-1 transition-all duration-300"
                        style={{ fontFamily: "'Theinhardt Pan', sans-serif" }}
                      >
                        {showTranslatedValue(cat.name)}
                      </span>
                    </Link>
                  </li>
                );
              })}
            {/* <li className="header-list">
              <Link className="relative a-tag eshop" style={{ color: "#000" }}>
                {showTranslatedValue(headerData?.headerMenu1)}
              </Link>

             
              <div
                className="e-shop-container"
                onMouseEnter={() => {
                  dispatch(changeScrolling(true));
                }}
                onMouseLeave={() => {
                  dispatch(changeScrolling(false));
                }}
              >
                <div className="e-shop-body items-stretch">
                  <RenderCategories
                    categories={data[0]?.children?.filter(
                      (cat) =>
                        !["metals", "stones", "macrame"].some((slug) =>
                          cat.slug?.toLowerCase().includes(slug)
                        )
                    )}
                  />
                
                  <div className="header-products">
                    {headerData?.showHeaderBanner1 && (
                      <div style={{ overflow: "hidden" }}>
                        <h6 className="header-sub-header">
                          {showTranslatedValue(headerData?.headerBannerText1)}
                        </h6>
                        <Link
                          to={`eshop${headerData?.headerBanner1Link}`}
                          className="header-img"
                          style={{ marginBottom: "20px" }}
                        >
                          <img
                            src={`${BASE_URL_IMAGE}${headerData?.headerBannerImg1}`}
                            alt=""
                          />
                        </Link>
                        <div
                          className="text"
                          dangerouslySetInnerHTML={{
                            __html: showTranslatedValue(
                              headerData?.headerBannerDesc1
                            ),
                          }}
                        ></div>
                      </div>
                    )}
                    {headerData?.showHeaderBanner2 && (
                      <div style={{ overflow: "hidden" }}>
                        <h6 className="header-sub-header">
                          {showTranslatedValue(headerData?.headerBannerText2)}
                        </h6>
                        <Link
                          to={`eshop${headerData?.headerBanner2Link}`}
                          className="header-img"
                          style={{ marginBottom: "20px" }}
                        >
                          <img
                            src={`${BASE_URL_IMAGE}${headerData?.headerBannerImg2}`}
                            alt=""
                          />
                        </Link>
                        <div
                          className="text"
                          dangerouslySetInnerHTML={{
                            __html: showTranslatedValue(
                              headerData?.headerBannerDesc2
                            ),
                          }}
                        ></div>
                      </div>
                    )}

                    {headerData?.showHeaderBanner3 && (
                      <div style={{ overflow: "hidden" }}>
                        <h6 className="header-sub-header">
                          {showTranslatedValue(headerData?.headerBannerText3)}
                        </h6>
                        <Link
                          to={`eshop${headerData?.headerBanner3Link}`}
                          className="header-img"
                          style={{ marginBottom: "20px" }}
                        >
                          <img
                            src={`${BASE_URL_IMAGE}${headerData?.headerBannerImg3}`}
                            alt=""
                          />
                        </Link>
                        <div
                          className="text"
                          dangerouslySetInnerHTML={{
                            __html: showTranslatedValue(
                              headerData?.headerBannerDesc3
                            ),
                          }}
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </li> */}
            {showTranslatedValue(headerData?.headerMenu2) && (
              <li className="header-list">
                <Link
                  className="relative a-tag"
                  style={{ color: "#000" }}
                  to={headerData?.headerMenu2Link}
                >
                  {showTranslatedValue(headerData?.headerMenu2)}
                </Link>
              </li>
            )}
            {showTranslatedValue(headerData?.headerMenu3) && (
              <li className="header-list">
                <Link
                  className="a-tag"
                  style={{ color: "#000" }}
                  to={headerData?.headerMenu3Link}
                >
                  {showTranslatedValue(headerData?.headerMenu3)}
                </Link>
              </li>
            )}
            {showTranslatedValue(headerData?.headerMenu4) && (
              <li className="header-list">
                <Link
                  className="a-tag"
                  style={{ color: "#000" }}
                  to={headerData?.headerMenu4Link}
                >
                  {showTranslatedValue(headerData?.headerMenu4)}
                </Link>
              </li>
            )}
            {showTranslatedValue(headerData?.headerMenu5) && (
              <li className="header-list">
                <Link
                  className="a-tag"
                  style={{ color: "#000" }}
                  to={headerData?.headerMenu5Link}
                >
                  {showTranslatedValue(headerData?.headerMenu5)}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </header>

      {/* ----------> Eshop Header Mobile View <------------ */}

      <MobileHeaderWapper MobileHeaderWapper>
        <header
          className={`${!toggleSideBar ? "mobile-header" : ""} lg:hidden fixed top-0 left-0 flex w-full z-[9999] bg-white ${
            !toggleSideBar && "bg-[rgba(255,255,255,0.6)]"
          } backdrop-blur-xl`}
        >
          <div className="w-full flex px-4 py-3 justify-between items-center">
            <div className="flex gap-4 items-center justify-start w-4/12">
              <button
                className="bras-btn"
                onClick={() => {
                  setActiveCategory(null);
                  openSidebar();
                }}
              >
                {/* <img src="/images/p31.png" alt="" className="w-[80%]" /> */}
                {toggleSideBar ? (
                  <HiOutlineXMark className="text-2xl" />
                ) : (
                  <RiMenu2Fill className="text-2xl" />
                )}
              </button>
            </div>
            <Link to="/" className="w-4/12 flex justify-center items-center">
              {/* <div
                className="logo-home"
                style={{
                  backgroundImage: `url(${
                    logoC
                      ? `${BASE_URL_IMAGE}${headerData?.logo[0]}`
                      : `${BASE_URL_IMAGE}${headerData?.logo[0]}`
                  })`,
                }}
              ></div> */}
              <img
                src={`${BASE_URL_IMAGE}${headerData?.logo[0]}`}
                alt="Logo | Alma Jewellery Wholesale"
                width={120}
                height={120}
              />
            </Link>

            <div
              className="!w-4/12 home11-nav03 flex justify-end relative"
              style={{ gap: "18px" }}
            >
              <button onClick={HandleSearch}>
                {/* <img src={search} alt="" /> */}
                <CiSearch className="text-2xl mt-1" />
              </button>
              <button onClick={HandleCart} className="relative">
                <img src={cart} alt="" />
                <div className="mobile-cart-qty-circle-home !top-[-0.8rem] !right-[-0.5rem] !min-w-3 !min-h-3">
                  <span>{cartLength}</span>
                </div>
              </button>
            </div>
          </div>
        </header>
        <div
          className={`lg:hidden transition-all duration-200 w-full h-screen bg-[#FFFFFF] fixed top-0 ${
            toggleSideBar ? "left-0" : "left-[-110%]"
          } z-[999] overflow-x-hidden flex flex-col`}
        >
          <div className="flex-1 overflow-y-auto px-5 pt-[4rem] pb-4 relative">
            <div className="border-b border-[rgba(0,0,0,0.3)] py-2">
              <p className="text-xs opacity-60">Categories</p>
              <ul className="mt-2">
                {mobileNav?.categories?.map((category, index) => {
                  return (
                    <li
                      key={category.slug}
                      className="w-full flex items-center justify-between py-1"
                    >
                      <div
                        to="/"
                        onClick={() => {
                          handleRedict(category.slug);
                          setActiveCategory(null);
                          openSidebar();
                        }}
                        className="w-fit"
                      >
                        {showTranslatedValue(category.name)}
                      </div>
                      <div
                        className="pl-8 py-1 w-fit"
                        onClick={() => {
                          category?.children.length > 0
                            ? setActiveCategory(category)
                            : handleRedict(category.slug);
                        }}
                      >
                        <GoArrowRight className="text-xl" />
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="border-b border-[rgba(0,0,0,0.3)] py-2">
              <p className="text-xs opacity-60">Pages</p>
              <ul className="mt-2">
                {mobileNav?.pages?.map((page) => {
                  return (
                    <li
                      key={page?.link}
                      className="w-full flex items-center justify-between py-1"
                    >
                      <div
                        onClick={() => {
                          setActiveCategory(null);
                          openSidebar();
                          navigate(`${page?.link}`);
                        }}
                        className="w-fit"
                      >
                        {page?.title}
                      </div>
                      {/* <GoArrowRight className="text-xl" /> */}
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Inline lang/curr — shown only below 640px, flows after Pages */}
            <div className="mobile-lang-curr-inline">
              <div className="mobile-selector-row">
                <span className="mobile-selector-label">Language</span>
                <div className="mobile-custom-dropdown" onClick={() => { setLangOpen(!langOpen); setCurrOpen(false); }}>
                  <span className="mobile-dropdown-value">{languageName}</span>
                  <svg className={`mobile-dropdown-arrow ${langOpen ? "open" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                  {langOpen && (
                    <ul className="mobile-dropdown-list mobile-dropdown-list--up">
                      {languages?.map((eachLang) => (
                        <li
                          key={eachLang._id}
                          className={languageName === eachLang?.name?.toUpperCase() ? "active" : ""}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleLanguageChange({ lang: eachLang?.iso_code, name: eachLang?.name?.toUpperCase() });
                            setLangOpen(false);
                          }}
                        >
                          {eachLang?.name?.toUpperCase()}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="mobile-selector-row">
                <span className="mobile-selector-label">Currency</span>
                <div className="mobile-custom-dropdown" onClick={() => { setCurrOpen(!currOpen); setLangOpen(false); }}>
                  <span className="mobile-dropdown-value">{defaultCurrency}</span>
                  <svg className={`mobile-dropdown-arrow ${currOpen ? "open" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                  {currOpen && (
                    <ul className="mobile-dropdown-list mobile-dropdown-list--up">
                      {currencies?.map((eachCurr) => (
                        <li
                          key={eachCurr._id}
                          className={defaultCurrency === eachCurr?.code ? "active" : ""}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCurrencyChange({ code: eachCurr?.code, symbol: eachCurr.symbol });
                            setCurrOpen(false);
                          }}
                        >
                          {`${eachCurr?.name?.toUpperCase()} (${eachCurr?.symbol?.toUpperCase()})`}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Language & Currency — always pinned to bottom of sidebar */}
          <div className="mobile-lang-curr-section">
            {/* Row 1: Language */}
            <div className="mobile-selector-row">
              <span className="mobile-selector-label">Language</span>
              <div className="mobile-custom-dropdown" onClick={() => { setLangOpen(!langOpen); setCurrOpen(false); }}>
                <span className="mobile-dropdown-value">{languageName}</span>
                <svg className={`mobile-dropdown-arrow ${langOpen ? "open" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
                {langOpen && (
                  <ul className="mobile-dropdown-list mobile-dropdown-list--up">
                    {languages?.map((eachLang) => (
                      <li
                        key={eachLang._id}
                        className={languageName === eachLang?.name?.toUpperCase() ? "active" : ""}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleLanguageChange({ lang: eachLang?.iso_code, name: eachLang?.name?.toUpperCase() });
                          setLangOpen(false);
                        }}
                      >
                        {eachLang?.name?.toUpperCase()}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            {/* Row 2: Currency */}
            <div className="mobile-selector-row">
              <span className="mobile-selector-label">Currency</span>
              <div className="mobile-custom-dropdown" onClick={() => { setCurrOpen(!currOpen); setLangOpen(false); }}>
                <span className="mobile-dropdown-value">{defaultCurrency}</span>
                <svg className={`mobile-dropdown-arrow ${currOpen ? "open" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
                {currOpen && (
                  <ul className="mobile-dropdown-list mobile-dropdown-list--up">
                    {currencies?.map((eachCurr) => (
                      <li
                        key={eachCurr._id}
                        className={defaultCurrency === eachCurr?.code ? "active" : ""}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCurrencyChange({ code: eachCurr?.code, symbol: eachCurr.symbol });
                          setCurrOpen(false);
                        }}
                      >
                        {`${eachCurr?.name?.toUpperCase()} (${eachCurr?.symbol?.toUpperCase()})`}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>

          <div
            className={` transition-all duration-200 overflow-y-auto w-full h-full bg-[#FFFFFF] px-5 py-[4rem] absolute top-0 pb-[8rem] sm:pb-[4rem] ${
              activeCategory ? "left-0" : "left-[110%]"
            }`}
          >
            <div className="border-b border-[rgba(0,0,0,0.3)] py-2">
              <div
                className="text-md opacity-60 flex gap-2 items-center justify-start !text-black"
                onClick={() => setActiveCategory(null)}
              >
                <GoArrowRight className="text-xl rotate-180 mb-1" />
                <p className="leading-none">Back</p>
              </div>
              <ul className="mt-2">
                {activeCategory?.children?.map((child, index) => {
                  return (
                    <li
                      key={child.slug}
                      className="w-full flex items-center justify-between py-1"
                    >
                      <div
                        to="/"
                        onClick={() => {
                          setActiveCategory(null);
                          openSidebar();
                          handleRedict(child.slug);
                        }}
                        className="w-fit"
                      >
                        {showTranslatedValue(child.name)}
                      </div>
                      {/* <GoArrowRight
                        className="text-xl"
                        onClick={() => handleRedict(child.slug)}
                      /> */}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </MobileHeaderWapper>

      <SearchWrapper>
        <div
          className="search-box"
          style={searchSideBar ? { right: 0 } : { right: "-110%" }}
        >
          <button className="close-img" onClick={HandleSearch}>
            <img src={closeBtn} alt="" />
          </button>

          <div className="search-item-container">
            <div className="flex">
              <input
                type="text"
                className="search-input"
                placeholder="Search"
                value={searchTxt}
                onChange={(e) => setSearchTxt(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button
                className="right"
                onClick={handleSearchTxt}
                disabled={searchTxt.trim().length === 0}
              >
                <img src={RightArrow} alt="" />
              </button>
            </div>
          </div>
        </div>
      </SearchWrapper>
      <Cart cartBar={cartBar} HandleCart={HandleCart} />
    </Wrapper>
  );
}

export default AllHeader;

const Wrapper = styled.div`
  .showHeaderChild {
    font-family: "TheinhardtPan-Regular", sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #000 !important;
    font-weight: 500;
  }

  .showHeaderChild:hover {
    text-decoration: underline;
  }
`;

const MobileHeaderWapper = styled.div`
  .mobile-item a {
    color: #fff9f2 !important;
  }

  .close-img img {
    height: 37px;
    width: 37px;
  }

  .close-img {
    right: 26px;
    position: absolute;
    top: 26px;
  }

  /* ── Mobile Language & Currency section ── */
  .mobile-lang-curr-section {
    flex-shrink: 0;
    padding: 14px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .mobile-selector-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .mobile-selector-label {
    font-family: 'Theinhardt Pan', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #000000;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    white-space: nowrap;
    min-width: 68px;
  }

  .mobile-custom-dropdown {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 7px 12px;
    cursor: pointer;
    background: #fff;
    min-width: 120px;
    user-select: none;
    transition: border-color 0.2s ease;
  }

  .mobile-custom-dropdown:hover {
    border-color: #000;
  }

  .mobile-dropdown-value {
    font-family: 'Theinhardt Pan', sans-serif;
    font-size: 13px;
    font-weight: 300;
    color: #000;
    flex: 1;
  }

  .mobile-dropdown-arrow {
    width: 14px;
    height: 14px;
    color: #000;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  .mobile-dropdown-arrow.open {
    transform: rotate(180deg);
  }

  .mobile-dropdown-list {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    z-index: 9999;
    list-style: none;
    padding: 6px 0;
    margin: 0;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }

  .mobile-dropdown-list--up {
    top: auto;
    bottom: calc(100% + 4px);
    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  }

  .mobile-dropdown-list li {
    font-family: 'Theinhardt Pan', sans-serif;
    font-size: 13px;
    font-weight: 300;
    color: #000;
    padding: 8px 14px;
    cursor: pointer;
    transition: background 0.15s ease;
  }

  .mobile-dropdown-list li:hover {
    background: #f5f5f5;
  }

  .mobile-dropdown-list li.active {
    font-weight: 500;
    color: #a03907;
  }

  /* ── Inline block: visible only below 640px ── */
  .mobile-lang-curr-inline {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 16px;









    margin-top: 8px;
    padding-bottom: 8px;
  }

  /* ── Pinned bar: hidden below 640px ── */
  .mobile-lang-curr-section {
    display: none;
  }

  /* ── At ≥640px: show pinned bar, hide inline block ── */
  @media (min-width: 640px) {
    .mobile-lang-curr-section {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 24px;
    }

    .mobile-lang-curr-inline {
      display: none;
    }
  }
`;

const SearchWrapper = styled.div`
  @media (max-width: 497px) {
    .close-img img {
      height: 37px;
      width: 37px;
    }

    .close-img {
      right: 26px;
      position: absolute;
      top: 26px;
    }
  }
`;
